import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Grid from '@mui/material/Unstable_Grid2';
import LessonComponentService from '../../content/services/LessonComponentService';
import { LessonPointsView } from './LessonPointsView';
import React from 'react';
import Typography from '@mui/material/Typography';
import { isNil } from 'lodash';
import statusColors from '../../shared/styles/StatusColors.module.css';
import styles from '../styles/LessonComponentResultPanel.module.css';
import { useLessonComponentContext } from '../../content/models/LessonComponentContext';

interface LessonComponentResultPanelProps {
  correct?: boolean;
  message: string;
  points?: number;
  assignedPoints?: number;
}

export function LessonComponentResultPanel(
  props: LessonComponentResultPanelProps
) {
  const { componentType } = useLessonComponentContext();
  const isAutoMarking = LessonComponentService.isAutoMarking(componentType);

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      className={!isNil(props.correct) ? styles.feedbackContainer : ''}
    >
      {!isNil(props.correct) && props.assignedPoints > 0 && isAutoMarking && (
        <Grid className={styles.feedbackPoints}>
          <Grid container alignItems="center" justifyContent="center">
            <Grid className={styles.icon}>
              {props.correct && (
                <CheckCircleOutlineIcon className={statusColors.green} />
              )}
              {!props.correct && (
                <CancelOutlinedIcon className={statusColors.red} />
              )}
            </Grid>

            <Grid>
              <LessonPointsView
                points={props.points}
                assigned={props.assignedPoints}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
      {props.message && (
        <Grid className={styles.feedbackMessage}>
          <Typography variant="subtitle2">{props.message}</Typography>
        </Grid>
      )}
    </Grid>
  );
}
